jQuery(document).on('ready', function () {
	let $ = jQuery;

	$(window).on("scroll", function() {
		let header = $(".header");
		var scroll = $(window).scrollTop();

		if (scroll >= 50) {
			header.addClass("scrolled");
		} else {
			header.removeClass("scrolled");
		}
	});

		setTimeout(function () {
			$('.homepage-afterplay').fadeIn(850);
		}, 1000);



});

// AOS.init(
//
// );
AOS.init({
	once: true
});
